<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @doClear="initFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="inspectionRecordResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" checkboxColumnDisabled editDisable withCustomRowActions>
                                <template slot="customRowActions" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="task"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="$_emWorkflowListMixin_handleApprove(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2022-01-25 16:25:44
import emWorkflowListMixin from "@/mixin/em/workflow/list";

export default {
    name: "inspectionRecordWorkflowListView",
    mixins: [emWorkflowListMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        initFilter() {
            //清除设备档案跳转绑定的查询条件，清除按钮无法清空的问题
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('emArchBasicDataCodeFilter', null);
        }
    }
};
</script>